import antdEnGB from 'antd/locale/en_GB';
import antdEnUS from 'antd/locale/en_US';
import antdEsES from 'antd/locale/es_ES';
import antdFrFR from 'antd/locale/fr_FR';
import dayjs from 'dayjs';

import { Locale } from './types';

export function changeLocale(name: string) {
  dayjs.locale(name);
}

export function getLocale() {
  // Using `as` because no easy cast possible and the locale is anyway linked
  // to the ILanguage in ./types.ts
  return dayjs.locale() as Locale;
}

export function getAntLocaleConfig(language: Locale) {
  const antLocaleMap = {
    dev: antdFrFR,
    'en-GB': antdEnGB,
    'en-US': antdEnUS,
    es: antdEsES,
    fr: antdFrFR,
  };

  return antLocaleMap[language];
}
